module.exports = __webpack_public_path__ + "img/start_cima.d8d2ce0c.png";